import { TProduct } from 'shared/types';
import { http } from '../utils/axios';

class ProductsService {
  private static instance: ProductsService;

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  private constructor() {}

  public static getInstance(): ProductsService {
    if (!ProductsService.instance) {
      ProductsService.instance = new ProductsService();
    }

    return ProductsService.instance;
  }

  public getProducts = async ({ limit = 99, page = 1, q = '', affiliate }) => {
    const data = await http<{
      products: TProduct[];
      result: string[];
      count: number;
    }>({
      url: '/products',
      method: 'GET',
      params: {
        limit,
        q,
        page,
        affiliate
      }
    });

    return data;
  };
}

const instance = ProductsService.getInstance();

export default instance;
